import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import './BOCDeviceConnection.css'
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../shared/loader/Loader";
import EcoProButton from "../../../../shared/button/button";
import EcoProOverlayModal from "../../../../shared/modal/OverlayModal/EcoProOverlayModal";
import AdminFormInput from "../../../../AdminPortal/Shared/FormElements/FormInput/FormInput";
import { fetchBOCDeviceConnectionRequest, fetchBOCDeviceConnectionReset } from "../../../../../store/CSAgentPortal/BOC/BOCDeviceConnectionServiceSlice";
import { SUCCESS } from "../../../../../constants/AppConstants";

const BOCDeviceConnection = (props) => {

    const dispatch = useDispatch();
    const { t } = useTranslation(["CSAgenttranslation"]);

    // extract user id form props
    const { userId } = props || {};

    const modalPropsInitialState = {
        modal_title: "",
        modal_sub_title: "",
        modal_content: "",
        cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
        confirm_btn_text: t("MODAL_BUTTON_TXT.CONFIRM"),
        toggleModal: "",
        customClassName: "",
        confirm_btn_onClick: "",
        type: "normal",
        confirm_btn_disabled:false
    }
    const [modalState, setModalState] = useState(false);
    const [modalType, setModalType] = useState("input");
    const [modalProps, setModalProps] = useState(modalPropsInitialState);
    const [serialNumber, setSerialNumber] = useState(null);
    const BOCDeviceConnectionResponse = useSelector((state) => state.CSAGENT_RTK.BOCDeviceConnectionService);

    const handleDeviceSerialNumber = () => {
        setModalState(true);
        setModalType("input");
        setSerialNumber(null);
        dispatch(fetchBOCDeviceConnectionReset())
    };

    const toggleModal = () => {
        setModalState(!modalState);
    };

    const getBOCDeviceDetails = () => {
        setModalState(false);
        dispatch(fetchBOCDeviceConnectionRequest({ serialNumber, userId }));
    }

    useEffect(() => {
        if (!modalState) return;
        if (modalType === "input") {
            setModalProps({
                modal_title:  t('CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.TITLE'),
                modal_content: (
                    <AdminFormInput
                        id="bocdevicedetails-serialnumber-input"
                        name="bocdevicedetails-serialnumber-input"
                        onChange={(e) => setSerialNumber(e.target.value)}
                        value={serialNumber}
                        isRequired={true}
                        placeholder={t('CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.ENTER_SERIAL_NUMBER')}
                        type="text"
                        minLength={0}
                        maxLength={100}
                        cname={!serialNumber && 'is-danger'}
                    />
                ),
                cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
                confirm_btn_text: t("MODAL_BUTTON_TXT.CONFIRM"),
                toggleModal: toggleModal,
                customClassName: "customer-dashboard-swap-modal",
                confirm_btn_onClick: () => getBOCDeviceDetails(),
                type: "normal",
                confirm_btn_disabled: !serialNumber
            });
        };
        // eslint-disable-next-line
    }, [serialNumber, modalState, modalType]);

    return (
        <div>
            {
                BOCDeviceConnectionResponse?.loading &&
                <Loader setOverlay={true}></Loader>
            }
            <div className="device-details-btn-wrapper mt-20">
                <EcoProButton btnID="bocdevicedetails-serialnumber-btn" cname="default" onBtnClick={() => handleDeviceSerialNumber()}>
                    {t('CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.GET_BOC_DEVICE_DETAILS')}
                </EcoProButton>
            </div>
            <div className="mt-40">
                {
                    (BOCDeviceConnectionResponse?.success &&
                        BOCDeviceConnectionResponse.BOCDeviceConnectionService.actionStatus.toUpperCase() === SUCCESS) &&
                    <div className="BOCcontents">
                        <h2 className="mt-40">{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.TITLE")}</h2>
                        <div className="device-info">
                            <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.SERIAL_NUMBER")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.serialNumber}</span></p>
                            <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.FIRMWARE_VERSION")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.firmwareVersion}</span></p>
                            <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.MODEL")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.model}</span></p>
                            <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.NETWORK_STATUS")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.networkStatus}</span></p>
                        </div>

                        <div className="subscribed-services-info mt-40">
                            <h2>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.SUBSCRIBED_SERVICES_TITLE")}</h2>
                            {BOCDeviceConnectionResponse.BOCDeviceConnectionService.subscribedServices?.length > 0 ? (
                                BOCDeviceConnectionResponse.BOCDeviceConnectionService.subscribedServices.map((service, index) => (
                                    <div key={index}>
                                        <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.SERVICE_NAME")}: <span>{service.serviceName}
                                            {"("}{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.SERVICE_TYPE")}: <span>{service.serviceType}</span>{")"}</span></p>
                                    </div>
                                ))
                            ) : (
                                <div className="email-log-error">{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.NO_SUBSCRIBED_SERVICES")}</div>
                            )}
                        </div>

                        {
                            (BOCDeviceConnectionResponse.BOCDeviceConnectionService.subscribedUser != null) &&
                            <div className="subscribed-user-info mt-40">
                                <h2>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.SUBSCRIBED_USER_TITLE")}</h2>
                                <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.DISPLAY_NAME")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.subscribedUser?.displayName}</span></p>
                                <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.EMAIL_ID")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.subscribedUser?.emailId}</span></p>
                                <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.FIRST_NAME")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.subscribedUser?.firstName}</span></p>
                                <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.LAST_NAME")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.subscribedUser?.lastName}</span></p>
                                <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.SAP_BP_ID")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.subscribedUser?.sapBpId}</span></p>
                                <p>{t("CUSTOMER_DASHBOARD.BOC_DEVICE_CONNECTION.USER_ID")}: <span>{BOCDeviceConnectionResponse.BOCDeviceConnectionService.subscribedUser?.userId}</span></p>
                            </div>
                        }
                    </div>
                }
            </div>
            {
                (BOCDeviceConnectionResponse?.error ||
                    (BOCDeviceConnectionResponse?.success &&
                        BOCDeviceConnectionResponse.BOCDeviceConnectionService.actionStatus.toUpperCase() !== SUCCESS)) &&
                <div className="email-log-error">{`${t("ERROR_MESSAGES.NO_BOC_DETAILS")} for ${serialNumber}`}</div>
            }
            <EcoProOverlayModal {...modalProps} modal_state={modalState}></EcoProOverlayModal>
        </div>
    );
};

export default BOCDeviceConnection;
